import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import history from './history'
import exceptions from './tools/exceptions'

import configureStore from './tools/configureStore'
import { checkIsAuth } from './actions/sessionActions'
import { App } from './containers/app'

const store = configureStore(history)
checkIsAuth(store)
exceptions.init()

const render = (Component: React.ComponentType) => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div className="app">
            <Component />
          </div>
        </ConnectedRouter>
      </Provider>
    </AppContainer>,
    document.getElementById('root')
  )
}

render(App)

if (module.hot) {
  module.hot.accept('./containers/app', () => {
    render(App)
  })
}
